// extracted by mini-css-extract-plugin
module.exports = {"v-application":"ChipStatus_v-application_O5qsZ","text-h1":"ChipStatus_text-h1_1UN3q","text-h2":"ChipStatus_text-h2_cmhzp","chip":"ChipStatus_chip_2Pd4v"};